<header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
  <i class="me-2 fa-solid fa-bell" aria-hidden="true"></i>
  <h6 class="m-0">Настройки на известията</h6>
</header>
@if (!loading) {
  <form [formGroup]="notificationForm">
    <ul class="m-0 p-3 list-unstyled">
      @for (notification of notificationsArray.controls; track notification; let index = $index, last = $last) {
        <li [formGroup]="notification"
            [ngClass]="!last ? 'border-bottom mb-3 pb-3' : ''">
          <h6 class="m-0 text-primary-emphasis">{{ notificationTypes[index].notificationTypeName }}</h6>
          <p class="mb-2 small text-muted">{{ notificationTypes[index].notificationTypeDescription }}</p>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              formControlName="viaEmail"
              [id]="'email-' + notificationTypes[index].notificationTypeId"/>
            <label
              class="form-check-label"
              [for]="'email-' + notificationTypes[index].notificationTypeId">
              Получавайте чрез електонна поща
            </label>
          </div>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              formControlName="viaPlatform"
              [id]="'platform-' + notificationTypes[index].notificationTypeId"/>
            <label
              class="form-check-label"
              [for]="'platform-' + notificationTypes[index].notificationTypeId">
              Получавайте чрез известие в платформата
            </label>
          </div>
        </li>
      }
    </ul>
  </form>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h2>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h2>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
